export default function cents(amount) {
  if (amount) {
    return amount.toString().slice(-2);
  }
}